import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      width: '105px',
      backgroundColor: palette.background.box,
      borderRadius: '10px 10px 0px 0px',
      textAlign: 'center',
      fontWeight: 500,
      fontSize: '18px',
      padding: '5px 5px 0px 5px',
      cursor: 'pointer',
      userSelect: 'none',
      transition: '0.3s',
      '&:hover': {
        transform: 'scale(1.05)'
      },
      color: 'lightgrey'
    },
    selected: {
      zIndex: 1,
      backgroundColor: palette.background.box,
      color: '#545454'
    },
    classe: {
      height: '47px'
    },
    academie: {
      height: '66px'
    },
    niveau: {
      height: '79px'
    },
    national: {
      height: '99px'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
